import * as Sentry from '@sentry/react';

declare global {
  interface Window {
    __SENTRY_REPLAY_INIT__?: boolean;
  }
}

const sentryInit = () => {
  if (typeof window === 'undefined') return;
  if (window.__SENTRY_REPLAY_INIT__) return;
  Sentry.init({
    dsn: 'https://80649c0023938150701ccafa6772aaa9@o4507878927433728.ingest.de.sentry.io/4509699626762320',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        // Disable the injection of the default widget
        autoInject: false,
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  // Set the flag to true to prevent multiple initializations
  window.__SENTRY_REPLAY_INIT__ = true;
};

export default sentryInit;
